module.exports = __webpack_public_path__ + "img/banner2.291b71d6.png";